//Copyright 2018 Nathan Moore

export const SET_EDITOR = "SET_EDITOR";
